import { isDiscernableObject } from '@/backend/entities/isDiscernableObject';
import {
  type InvalidResult,
  ValidationError,
  ValidationException,
} from '@/backend/errors/ValidationError';

/**
 * Checks whether a value is a ValidationError
 *
 * @param a The value to check
 * @returns True if the value is a ValidationError
 */
export function isValidationError<T extends InvalidResult>(a: unknown): a is T {
  if (a instanceof ValidationError) {
    return true;
  }
  if (a instanceof ValidationException) {
    return true;
  }
  if (isDiscernableObject(a) && a.kind === 'ValidationError') {
    return true;
  }

  return false;
}
